import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Table } from 'react-bootstrap';
import { FaArrowLeft, FaEdit, FaLink, FaPlus, FaTrashAlt } from 'react-icons/fa';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import { useNavigate } from 'react-router-dom'; // Correct hook import

const SesionFeedback = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [sessionTopic, setSessionTopic] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sessions, setSessions] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [editingSessionId, setEditingSessionId] = useState(null);
    const itemsPerPage = 5;

    const navigate = useNavigate(); // Use the hook here

    useEffect(() => {
        fetchSessions();
    }, []);

    const fetchSessions = async () => {
        const response = await fetch('https://rvapi.emedha.in/pages/api/fdgsessions');
        const data = await response.json();

        console.log('Fetched sessions:', data); // 🔍 check what it returns

        if (Array.isArray(data)) {
            setSessions(data);
        } else if (data?.sessions && Array.isArray(data.sessions)) {
            setSessions(data.sessions);
        } else {
            console.error("Invalid session data format:", data);
            setSessions([]); // prevent crash
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const method = editingSessionId ? 'PUT' : 'POST';
        const url = editingSessionId
            ? `https://rvapi.emedha.in/pages/api/fdesessions/${editingSessionId}`
            : 'https://rvapi.emedha.in/pages/api/fdpsessions';

        const response = await fetch(url, {
            method,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sessionTopic, startDate, endDate }),
        });

        const data = await response.json();
        if (method === 'POST') {
            setSessions([...sessions, data]);
            alert('Session added successfully!');
        } else {
            setSessions(
                sessions.map((session) =>
                    session.id === editingSessionId ? data : session
                )
            );
            alert('Session updated successfully!');
        }

        setIsModalOpen(false);
        setSessionTopic('');
        setStartDate('');
        setEndDate('');
        setEditingSessionId(null);
    };

    const handleDelete = async (id) => {
        await fetch(`https://rvapi.emedha.in/pages/api/fddsessions/${id}`, {
            method: 'DELETE',
        });
        setSessions(sessions.filter((session) => session.id !== id));
        alert('Session Delete successfully!');
    };

    const handleEdit = (session) => {
        setSessionTopic(session.sessionTopic);
        setStartDate(session.startDate);
        setEndDate(session.endDate);
        setEditingSessionId(session.id);
        setIsModalOpen(true);
    };

    const handlePagination = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const indexOfLastSession = currentPage * itemsPerPage;
    const indexOfFirstSession = indexOfLastSession - itemsPerPage;
    const currentSessions = sessions.slice(indexOfFirstSession, indexOfLastSession);

    const handleGenerateUrl = (session) => {
        navigate(`/FeedbackForm/${session.id}/feedbackForm-in-feedbackForm`);
    };

    return (
        <div className="mt-1" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <img src={H1} alt="item" className="img-fluid" style={{ height: '200px', width: '100%' }} />

            <div className="container d-flex justify-content-between mt-3">
                <Button className="btn btn-dark" onClick={() => window.history.back()}><FaArrowLeft /> Back</Button>
                <Button className="btn btn-success" onClick={() => setIsModalOpen(true)}><FaPlus /> Add Session For Feedback</Button>
            </div>

            <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{editingSessionId ? 'Edit Session' : 'Add Session'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formSessionTopic">
                            <Form.Label>Session Topic</Form.Label>
                            <Form.Control type="text" value={sessionTopic} onChange={(e) => setSessionTopic(e.target.value)} placeholder="Enter session topic" />
                        </Form.Group>
                        <Form.Group controlId="formStartDate" className="mt-3">
                            <Form.Label>Start Date & Time</Form.Label>
                            <Form.Control type="datetime-local" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                        </Form.Group>
                        <Form.Group controlId="formEndDate" className="mt-3">
                            <Form.Label>End Date & Time</Form.Label>
                            <Form.Control type="datetime-local" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                        </Form.Group>
                        <Button type="submit" className="btn btn-success mt-3">
                            {editingSessionId ? 'Update' : 'Submit'}
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>

            <div className="container mt-4">
                <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Session Topic</th>
                            <th>Start Date & Time</th>
                            <th>End Date & Time</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentSessions.map((session, index) => (
                            <tr key={session.id}>
                                <td>{index + 1}</td>
                                <td>{session.sessionTopic}</td>
                                <td>{new Date(session.startDate).toLocaleString()}</td>
                                <td>{new Date(session.endDate).toLocaleString()}</td>
                                <td>
                                    <Button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(session)}><FaEdit /> Edit</Button>
                                    <Button className="btn btn-danger btn-sm me-2" onClick={() => handleDelete(session.id)}><FaTrashAlt /> Delete</Button>
                                    <Button className="btn btn-info btn-sm" onClick={() => handleGenerateUrl(session)}><FaLink /> Get URL</Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <button onClick={() => handlePagination(currentPage - 1)} disabled={currentPage === 1} className="btn btn-primary btn-sm">Previous</button>
                    <span style={{ margin: '0 10px' }}>Page {currentPage}</span>
                    <button onClick={() => handlePagination(currentPage + 1)} disabled={currentPage * itemsPerPage >= sessions.length} className="btn btn-primary btn-sm">Next</button>
                </div>
            </div>

            <footer style={{ backgroundColor: '#f1f1f1', padding: '20px 0', textAlign: 'center', marginTop: 'auto' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>
                        Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px', }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </div>
    );
};

export default SesionFeedback;
